export const IDENTIFIER_TYPE = [
  {
    text: 'Unknown',
    value: '-',
  },
  {
    text: "Driver's license",
    value: 'A',
  },
  {
    text: 'National identity card',
    value: 'B',
  },
  {
    text: 'Passport',
    value: 'C',
  },
  {
    text: 'Registration number',
    value: 'R',
  },
] as const;

export type IdentifierType = (typeof IDENTIFIER_TYPE)[number]['value'] | '';
